import { t } from 'i18next';

export const REFUND_REQUEST_REASONS = [
  {
    id: 1,
    type: 'pricey',
    title: t('SubscriptionCancel.refundRequestReasons.pricey') as string
  },
  {
    id: 2,
    type: 'low_usage',
    title: t('SubscriptionCancel.refundRequestReasons.lowUsage') as string
  },
  {
    id: 3,
    type: 'changed_my_mind',
    title: t('SubscriptionCancel.refundRequestReasons.awkwardReply') as string
  },
  {
    id: 4,
    type: 'others',
    title: t('SubscriptionCancel.refundRequestReasons.others') as string
  }
];
